import React, { useState } from 'react'
import { Button } from '../ui/button'
import { XCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import useCancelTodo from '@/services/api/to-do/useCancelTodo'

export default function DeleteButton({ id }: { id: number }) {
  const [open, setOpen] = useState(false)
  const { action: cancel, status } = useCancelTodo({ id })

  async function deleteMoneyPathTransfer() {
    await cancel()
    setOpen(false)
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button iconOnly variant="ghost" title="Cancel">
          <XCircleIcon />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Cancel Money Path Transfer</DialogTitle>
          <DialogClose>
            <XMarkIcon />
          </DialogClose>
        </DialogHeader>

        <DialogBody>
          <p>Are you sure, you want to cancel?</p>
        </DialogBody>

        <DialogFooter>
          <Button
            type="button"
            variant="destructive"
            onClick={deleteMoneyPathTransfer}
            loading={status.status === 'pending'}
          >
            Yes
          </Button>

          <DialogClose asChild>
            <Button type="button" variant="secondary">
              No
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
